import ClipboardCopy from "clipboard-copy";

export default {
  copy(text) {
    try {
      return ClipboardCopy(text);
    } catch {}
  }
};
